// extracted by mini-css-extract-plugin
module.exports = {"desktopOnly":"admin-bar_desktopOnly__Z6L72"};